// extracted by mini-css-extract-plugin
export default {"header":"ServiceFieldsTariffItem_header__5nU2+"};